import { constantTree } from "../../../core/events/ConstantTree";

export const srReqClaimTree = constantTree({
    Reset: {
        Atom: ""
    },
    Booking: {
        GetDetails: "",
        TabDefaultChange: "",
    },
    RequestClaimDetail: {
        FlowStarted: "",
        FlowTearDown: "",
        OpenAction: "",
        OpenCommentAction: "",
        KeepAction: "",
        CloseAction: "",
        GetBooking: "",
        AddComment: "",
        ActiveTicket: "",
        BackClick: ""
    },
    RequestClaim: {
        FlowStarted: "",
        Save: "",
        ShouldRenderFiled: "",
        RequiredValidation: "",
        handleChange: "",
        setFields: "",
        SuccessModal: "",
        OnPassengerCheckBoxChange: "",
        ClaimDetail: "",
        TicketList: {
            Get: ""
        }
    },
    Category: {
        Get: "",
        onChange: ""
    }
})